import React, { useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { getFiscaliteResume, getTvaDetails, getStations } from '../services/api';

const Fiscalite: React.FC = () => {
  const { user } = useAuth();
  const [tab, setTab] = useState<'resume' | 'tva' | 'parametres'>('resume');
  const [resume, setResume] = useState<any>(null);
  const [tvaDetails, setTvaDetails] = useState<any[]>([]);
  const [stations, setStations] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({ station_id: '', mois: new Date().toISOString().slice(0, 7) });

  const isGlobal = user && ['superadmin', 'admin_siege', 'comptable', 'financier', 'fiscaliste'].includes(user.role);

  useEffect(() => { loadStations(); }, []);
  useEffect(() => { loadData(); }, [tab, filters]);

  const loadStations = async () => {
    try { const res = await getStations(); setStations(res.data); } catch (err) { console.error(err); }
  };

  const loadData = async () => {
    setLoading(true);
    try {
      const params: any = {};
      if (filters.station_id) params.station_id = filters.station_id;
      if (filters.mois) params.mois = filters.mois;

      if (tab === 'resume' || tab === 'tva') {
        const [resR, resT] = await Promise.all([getFiscaliteResume(params), getTvaDetails(params)]);
        setResume(resR.data);
        setTvaDetails(resT.data);
      }
    } catch (err) { console.error(err); }
    setLoading(false);
  };

  const fmt = (n: number) => n.toLocaleString('fr-FR', { minimumFractionDigits: 0 });

  return (
    <div>
      <div className="page-header">
        <h2>Fiscalite</h2>
      </div>

      <div style={{ display: 'flex', gap: 0, marginBottom: 20, borderBottom: '2px solid #eee' }}>
        {[
          { key: 'resume', label: 'Resume Fiscal' },
          { key: 'tva', label: 'TVA Detaillee' },
          { key: 'parametres', label: 'Parametres Taxes' }
        ].map(t => (
          <button key={t.key} onClick={() => setTab(t.key as any)}
            style={{ padding: '10px 24px', border: 'none', background: tab === t.key ? '#004A97' : 'transparent', color: tab === t.key ? '#fff' : '#666', cursor: 'pointer', fontWeight: tab === t.key ? 600 : 400, borderRadius: '6px 6px 0 0', fontSize: 14 }}>
            {t.label}
          </button>
        ))}
      </div>

      <div className="filters" style={{ marginBottom: 16 }}>
        {isGlobal && (
          <select value={filters.station_id} onChange={e => setFilters({ ...filters, station_id: e.target.value })}>
            <option value="">Toutes les stations</option>
            {stations.map((s: any) => <option key={s.id} value={s.id}>{s.nom}</option>)}
          </select>
        )}
        <input type="month" value={filters.mois} onChange={e => setFilters({ ...filters, mois: e.target.value })} />
      </div>

      {loading ? <div className="loading">Chargement...</div> : (
        <>
          {tab === 'resume' && resume && (
            <div>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 16, marginBottom: 24 }}>
                <div className="card" style={{ padding: 20, textAlign: 'center' }}>
                  <div style={{ fontSize: 12, color: '#888', textTransform: 'uppercase' }}>CA HT</div>
                  <div style={{ fontSize: 26, fontWeight: 700, color: '#004A97', marginTop: 8 }}>{fmt(resume.ca_ht)}</div>
                  <div style={{ fontSize: 12, color: '#888' }}>FCFA</div>
                </div>
                <div className="card" style={{ padding: 20, textAlign: 'center' }}>
                  <div style={{ fontSize: 12, color: '#888', textTransform: 'uppercase' }}>TVA Collectee</div>
                  <div style={{ fontSize: 26, fontWeight: 700, color: '#ED0000', marginTop: 8 }}>{fmt(resume.tva_collectee)}</div>
                  <div style={{ fontSize: 12, color: '#888' }}>FCFA</div>
                </div>
                <div className="card" style={{ padding: 20, textAlign: 'center' }}>
                  <div style={{ fontSize: 12, color: '#888', textTransform: 'uppercase' }}>TVA Deductible</div>
                  <div style={{ fontSize: 26, fontWeight: 700, color: '#78BE20', marginTop: 8 }}>{fmt(resume.tva_deductible)}</div>
                  <div style={{ fontSize: 12, color: '#888' }}>FCFA</div>
                </div>
                <div className="card" style={{ padding: 20, textAlign: 'center' }}>
                  <div style={{ fontSize: 12, color: '#888', textTransform: 'uppercase' }}>TVA a reverser</div>
                  <div style={{ fontSize: 26, fontWeight: 700, color: resume.tva_nette >= 0 ? '#ED0000' : '#78BE20', marginTop: 8 }}>{fmt(resume.tva_nette)}</div>
                  <div style={{ fontSize: 12, color: '#888' }}>FCFA</div>
                </div>
              </div>

              <div className="card">
                <div className="card-header"><h3>Detail par station</h3></div>
                <div className="card-body">
                  <table className="table">
                    <thead>
                      <tr><th>Station</th><th style={{ textAlign: 'right' }}>CA HT</th><th style={{ textAlign: 'right' }}>TVA Collectee</th><th style={{ textAlign: 'right' }}>TVA Deductible</th><th style={{ textAlign: 'right' }}>TVA Nette</th></tr>
                    </thead>
                    <tbody>
                      {resume.par_station?.map((s: any) => (
                        <tr key={s.station_id}>
                          <td><strong>{s.station_nom}</strong></td>
                          <td style={{ textAlign: 'right' }}>{fmt(s.ca_ht)}</td>
                          <td style={{ textAlign: 'right' }}>{fmt(s.tva_collectee)}</td>
                          <td style={{ textAlign: 'right' }}>{fmt(s.tva_deductible)}</td>
                          <td style={{ textAlign: 'right', fontWeight: 600 }}>{fmt(s.tva_nette)}</td>
                        </tr>
                      ))}
                      {(!resume.par_station || resume.par_station.length === 0) && <tr><td colSpan={5} style={{ textAlign: 'center', padding: 20 }}>Aucune donnee</td></tr>}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}

          {tab === 'tva' && (
            <table className="table">
              <thead>
                <tr><th>Produit</th><th>Taux TVA</th><th style={{ textAlign: 'right' }}>CA TTC</th><th style={{ textAlign: 'right' }}>CA HT</th><th style={{ textAlign: 'right' }}>TVA</th></tr>
              </thead>
              <tbody>
                {tvaDetails.map((t: any, i: number) => (
                  <tr key={i}>
                    <td><strong>{t.produit_nom}</strong></td>
                    <td>{t.tva_rate}%</td>
                    <td style={{ textAlign: 'right' }}>{fmt(t.ca_ttc)}</td>
                    <td style={{ textAlign: 'right' }}>{fmt(t.ca_ht)}</td>
                    <td style={{ textAlign: 'right', fontWeight: 600 }}>{fmt(t.tva)}</td>
                  </tr>
                ))}
                {tvaDetails.length === 0 && <tr><td colSpan={5} style={{ textAlign: 'center', padding: 30 }}>Aucune donnee</td></tr>}
              </tbody>
              {tvaDetails.length > 0 && (
                <tfoot>
                  <tr style={{ fontWeight: 700, background: '#f8f9fa' }}>
                    <td colSpan={2}>Total</td>
                    <td style={{ textAlign: 'right' }}>{fmt(tvaDetails.reduce((s, t) => s + t.ca_ttc, 0))}</td>
                    <td style={{ textAlign: 'right' }}>{fmt(tvaDetails.reduce((s, t) => s + t.ca_ht, 0))}</td>
                    <td style={{ textAlign: 'right' }}>{fmt(tvaDetails.reduce((s, t) => s + t.tva, 0))}</td>
                  </tr>
                </tfoot>
              )}
            </table>
          )}

          {tab === 'parametres' && (
            <div className="card" style={{ maxWidth: 600 }}>
              <div className="card-header"><h3>Parametrage des taxes</h3></div>
              <div className="card-body">
                <table className="table">
                  <thead><tr><th>Taxe</th><th>Taux</th><th>Applicable</th></tr></thead>
                  <tbody>
                    <tr><td>TVA Standard</td><td>18%</td><td>Carburants, lubrifiants, services</td></tr>
                    <tr><td>TVA Reduite</td><td>0%</td><td>-</td></tr>
                    <tr><td>CFCE</td><td>1.5%</td><td>Contribution fonciere</td></tr>
                    <tr><td>Patente</td><td>Variable</td><td>Selon chiffre d'affaires</td></tr>
                  </tbody>
                </table>
                <div style={{ marginTop: 16, padding: 12, background: '#fff3e0', borderRadius: 6, fontSize: 13 }}>
                  Les taux de TVA sont configures par produit dans la fiche produit. Le taux standard au Senegal est de 18%.
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default Fiscalite;
